// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: metadata.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AggregationType,
  aggregationTypeFromJSON,
  aggregationTypeToJSON,
  BenchmarkType,
  benchmarkTypeFromJSON,
  benchmarkTypeToJSON,
  ColumnType,
  columnTypeFromJSON,
  columnTypeToJSON,
  DataSourceType,
  dataSourceTypeFromJSON,
  dataSourceTypeToJSON,
  DataType,
  dataTypeFromJSON,
  dataTypeToJSON,
  FilterOperator,
  filterOperatorFromJSON,
  filterOperatorToJSON,
  HeaderStatus,
  headerStatusFromJSON,
  headerStatusToJSON,
  MetadataTypeEnum,
  metadataTypeEnumFromJSON,
  metadataTypeEnumToJSON,
  MetricEdgeType,
  metricEdgeTypeFromJSON,
  metricEdgeTypeToJSON,
  MetricType,
  metricTypeFromJSON,
  metricTypeToJSON,
  PolarityEnum,
  polarityEnumFromJSON,
  polarityEnumToJSON,
  SortByEnum,
  sortByEnumFromJSON,
  sortByEnumToJSON,
  TimeBucket,
  timeBucketFromJSON,
  timeBucketToJSON,
} from "./enums";
import { DateFilter, GrowthBenchmarkProto } from "./relative_date";

export const protobufPackage = "com.meritic.newton";

/** Header of any metadata containing basic information. */
export interface Header {
  /** Unique identifier for the metadata object. */
  id?:
    | string
    | undefined;
  /** Name and description of the object. */
  name?: string | undefined;
  description?:
    | string
    | undefined;
  /** Type of metadata object. */
  type?:
    | MetadataTypeEnum
    | undefined;
  /** Id of the owner object. */
  owner_id?:
    | string
    | undefined;
  /** Author is the user who created this object. */
  author_id?: string | undefined;
  author_name?:
    | string
    | undefined;
  /** Date epoch in milliseconds when the object was created. */
  created_date_ms?:
    | number
    | undefined;
  /** Date epoch in milliseconds when the object was last modified. */
  last_modified_date_ms?:
    | number
    | undefined;
  /** Id of the user who last modified this object. */
  last_modified_by?:
    | string
    | undefined;
  /** Name of the user who last modified this object. */
  last_modified_by_name?:
    | string
    | undefined;
  /** status flag of the header */
  status_flag?:
    | HeaderStatus
    | undefined;
  /** Benchmark type. */
  benchmark_type?:
    | BenchmarkType
    | undefined;
  /** KG column type. */
  column_type?:
    | ColumnType
    | undefined;
  /** status of active schedules */
  has_active_schedule?:
    | boolean
    | undefined;
  /** true if the entity is incomplete */
  incomplete?: boolean | undefined;
}

/** Details of the data source. */
export interface DataSourceInfo {
  source_type?:
    | DataSourceType
    | undefined;
  /** Database, schema and table names are necessary to define a data source. */
  db_name?: string | undefined;
  schema_name?: string | undefined;
  table_name?:
    | string
    | undefined;
  /** Id of the worksheet, if the data source type is ThoughtSpot. */
  ts_worksheet_id?: string | undefined;
}

/** Logical column information. */
export interface ColumnInfo {
  header?:
    | Header
    | undefined;
  /** Name of external column if it is associated with some data source. */
  source_column_name?: string | undefined;
  data_type?: DataType | undefined;
  column_type?:
    | ColumnType
    | undefined;
  /** Default aggregation to be applied on measure column. */
  default_aggregation?: AggregationType | undefined;
}

/** Data model information. */
export interface ModelInfo {
  header?:
    | Header
    | undefined;
  /** Data source information if the model corresponds to an external table. */
  data_source?:
    | DataSourceInfo
    | undefined;
  /** List of columns in the model. */
  columns: ColumnInfo[];
  /**
   * Indicates if the data model contains target dataset.
   * Default value is false.
   */
  is_target_model?: boolean | undefined;
}

/** Representation of an output column in the observation. */
export interface ObservationColumnProto {
  /** Id of the observation column. */
  column_id?:
    | string
    | undefined;
  /** Header of the logical column. */
  logical_column_header?:
    | Header
    | undefined;
  /** Header of the KG column. */
  kg_column_header?:
    | Header
    | undefined;
  /** Aggregation to be applied on the column. */
  aggregation?:
    | AggregationType
    | undefined;
  /** Bucketing to be applied on temporal column. */
  time_bucket?:
    | TimeBucket
    | undefined;
  /** Sorting to be applied on the column. */
  sort_by?:
    | SortByEnum
    | undefined;
  /** Indicates if the column is used to find materiality of the metric values. */
  is_material?:
    | boolean
    | undefined;
  /** Column type of the observation column. */
  column_type?:
    | ColumnType
    | undefined;
  /** Data type of the observation column. */
  data_type?: DataType | undefined;
}

/** Representation of a filter. */
export interface FilterProto {
  /** Id of the filter. */
  filter_id?:
    | string
    | undefined;
  /** Header of the logical column on which filter is applied. */
  logical_column_header?:
    | Header
    | undefined;
  /** Header of the kg column on which filter is applied. */
  kg_column_header?:
    | Header
    | undefined;
  /**
   * Operators will be different for different data types and types of column:
   * EQ, NE, GT, GTE, LT, LTE, BTW ==> measures, dates, numeric attributes
   * CONTAINS, NOT_CONTAINS, LIKE, IN, NOT_IN  ==> string attributes
   * LAST_N_{BUCKET}, N_{BUCKET}_AGO ==> dates, datetime
   * Only some operators are supported as of now.
   * Operator in the filter expression.
   */
  operator?:
    | FilterOperator
    | undefined;
  /** Values in the filter expression. */
  values: string[];
  /** logical column of the filter */
  logical_column?:
    | ColumnInfo
    | undefined;
  /** Filter for query date range or specific date. */
  date_filter?:
    | DateFilter
    | undefined;
  /**
   * Date range calculated for the given date filter.
   * This may be used by clients and avoid doing the date calculations themselves.
   */
  calculated_date_ranges: FilterProto_CalculatedDateRange[];
  /** Hidden filter is used in data scope definition for the analyst. */
  is_hidden?: boolean | undefined;
}

/** Date range which is computed by newton for the given date filter. */
export interface FilterProto_CalculatedDateRange {
  operator?:
    | FilterOperator
    | undefined;
  /** Epoch in seconds corresponding to the calculated date. */
  date_epoch_sec?: number | undefined;
}

/** Representation of the content in the observation. */
export interface ObservationContentProto {
  /** List of output/visualisation columns in the observation. */
  observation_columns: ObservationColumnProto[];
  /** List of filters in this observation. */
  filters: FilterProto[];
}

/** Representation of an observation. */
export interface ObservationProto {
  header?: Header | undefined;
  content?: ObservationContentProto | undefined;
}

/** Representation of a metric. */
export interface MetricProto {
  header?:
    | Header
    | undefined;
  /** Definition of metric. */
  definition?:
    | ObservationContentProto
    | undefined;
  /** List of metric edges. */
  edges: MetricEdgeProto[];
  /** Formatting to use for metric values. */
  format?:
    | FormatProto
    | undefined;
  /** Type of metric. */
  type?:
    | MetricType
    | undefined;
  /** Polarity of metric. */
  polarity?:
    | PolarityEnum
    | undefined;
  /** Outcome profile for the metric to use. */
  outcome_profile?:
    | string
    | undefined;
  /** Header of the logical column used to find the materiality of metric values. */
  material_column_header?:
    | Header
    | undefined;
  /** Material metric for this metric. */
  material?: MetricProto | undefined;
}

/** Representation of a metric edge. */
export interface MetricEdgeProto {
  /** Type of edge. */
  edge_type?:
    | MetricEdgeType
    | undefined;
  /** Weight of edge. */
  edge_weight?:
    | number
    | undefined;
  /** Id of the source metric. */
  source_metric_id?:
    | string
    | undefined;
  /** Header of destination. */
  header?:
    | Header
    | undefined;
  /** One of the following will be set based on the edge type. */
  related_attribute?: Header | undefined;
  benchmark?: BenchmarkProto | undefined;
  fundamental_relationship?: FundamentalRelationshipProto | undefined;
}

/** Representation of a metric benchmark. */
export interface BenchmarkProto {
  header?:
    | Header
    | undefined;
  /** Filters to add/replace in the metric definition to get benchmark values. */
  benchmark_filters: FilterProto[];
  /** Tolerance level of the metric variance from benchmark. */
  variance_tolerance?:
    | number
    | undefined;
  /**
   * For temporal benchmark filters, if last_n_period_average > 1,
   * then we include the average of last N periods as another benchmark.
   */
  last_n_period_average?:
    | number
    | undefined;
  /**
   * List of growth benchmarks (max size = 2).
   * First element should be PRIOR_PERIOD or PRIOR_YEAR.
   * Second element is currently used for LAST_N_PERIOD_AGGR.
   */
  growth_benchmarks: GrowthBenchmarkProto[];
  /**
   * @constraint: Only one of benchmark filters or definition should be set.
   * Definition of target benchmark.
   */
  definition?: ObservationContentProto | undefined;
}

/** Representation of a metric correlation. */
export interface CorrelationProto {
  /** Correlation factor. */
  correlation_factor?:
    | number
    | undefined;
  /**
   * Only one of the following should be present.
   * Header of the correlated metric.
   */
  related_metric_header?:
    | Header
    | undefined;
  /** Header of the correlated measure column. */
  related_column_header?: Header | undefined;
}

/** Represents a fundamental relationship. */
export interface FundamentalRelationshipProto {
  /** Header of the fundamental relationship. */
  header?:
    | Header
    | undefined;
  /** Formula details in the relationship. */
  is_formula?: boolean | undefined;
  formula_expression?:
    | string
    | undefined;
  /** List of all correlations in the relationship. */
  correlations: CorrelationProto[];
  /** Indicates whether the formula is additive or not. */
  is_additive?: boolean | undefined;
}

/** Representation of formatting patterns that should be used to format the data values. */
export interface FormatProto {
  /**
   * The ISO 4217 code of the currency.
   * This is used to format the data value as currency amount.
   */
  currency_code?:
    | string
    | undefined;
  /** True if the value represents a percentage point, false otherwise. */
  percentage?:
    | boolean
    | undefined;
  /** Any arbitrary suffix that should be added to data value while formatting. */
  suffix?:
    | string
    | undefined;
  /** Number of decimal places to use to format values. */
  num_decimals?: number | undefined;
}

/** Proto representation of Page. */
export interface ReportPageProto {
  /** Header of the page. */
  header?:
    | Header
    | undefined;
  /** Headers of the trees in the page. */
  tree_headers: Header[];
}

/** Proto representation of report. */
export interface ReportBookProto {
  /** Header of the report. */
  header?:
    | Header
    | undefined;
  /** Pages in the report. */
  pages: ReportPageProto[];
}

/** Representation of error detail. */
export interface ErrorDetailProto {
  error_code?: number | undefined;
  error_name?: string | undefined;
  error_msg?: string | undefined;
  stack_trace?: string | undefined;
}

function createBaseHeader(): Header {
  return {
    id: undefined,
    name: undefined,
    description: undefined,
    type: undefined,
    owner_id: undefined,
    author_id: undefined,
    author_name: undefined,
    created_date_ms: undefined,
    last_modified_date_ms: undefined,
    last_modified_by: undefined,
    last_modified_by_name: undefined,
    status_flag: undefined,
    benchmark_type: undefined,
    column_type: undefined,
    has_active_schedule: undefined,
    incomplete: undefined,
  };
}

export const Header: MessageFns<Header> = {
  encode(message: Header, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.type !== undefined) {
      writer.uint32(32).int32(message.type);
    }
    if (message.owner_id !== undefined) {
      writer.uint32(42).string(message.owner_id);
    }
    if (message.author_id !== undefined) {
      writer.uint32(50).string(message.author_id);
    }
    if (message.author_name !== undefined) {
      writer.uint32(58).string(message.author_name);
    }
    if (message.created_date_ms !== undefined) {
      writer.uint32(64).int64(message.created_date_ms);
    }
    if (message.last_modified_date_ms !== undefined) {
      writer.uint32(72).int64(message.last_modified_date_ms);
    }
    if (message.last_modified_by !== undefined) {
      writer.uint32(82).string(message.last_modified_by);
    }
    if (message.last_modified_by_name !== undefined) {
      writer.uint32(90).string(message.last_modified_by_name);
    }
    if (message.status_flag !== undefined) {
      writer.uint32(96).int32(message.status_flag);
    }
    if (message.benchmark_type !== undefined) {
      writer.uint32(104).int32(message.benchmark_type);
    }
    if (message.column_type !== undefined) {
      writer.uint32(112).int32(message.column_type);
    }
    if (message.has_active_schedule !== undefined) {
      writer.uint32(120).bool(message.has_active_schedule);
    }
    if (message.incomplete !== undefined) {
      writer.uint32(128).bool(message.incomplete);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Header {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.owner_id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.author_id = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.author_name = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.created_date_ms = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.last_modified_date_ms = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.last_modified_by = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.last_modified_by_name = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.status_flag = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.benchmark_type = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.column_type = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.has_active_schedule = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.incomplete = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Header {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      type: isSet(object.type) ? metadataTypeEnumFromJSON(object.type) : undefined,
      owner_id: isSet(object.owner_id) ? globalThis.String(object.owner_id) : undefined,
      author_id: isSet(object.author_id) ? globalThis.String(object.author_id) : undefined,
      author_name: isSet(object.author_name) ? globalThis.String(object.author_name) : undefined,
      created_date_ms: isSet(object.created_date_ms) ? globalThis.Number(object.created_date_ms) : undefined,
      last_modified_date_ms: isSet(object.last_modified_date_ms)
        ? globalThis.Number(object.last_modified_date_ms)
        : undefined,
      last_modified_by: isSet(object.last_modified_by) ? globalThis.String(object.last_modified_by) : undefined,
      last_modified_by_name: isSet(object.last_modified_by_name)
        ? globalThis.String(object.last_modified_by_name)
        : undefined,
      status_flag: isSet(object.status_flag) ? headerStatusFromJSON(object.status_flag) : undefined,
      benchmark_type: isSet(object.benchmark_type) ? benchmarkTypeFromJSON(object.benchmark_type) : undefined,
      column_type: isSet(object.column_type) ? columnTypeFromJSON(object.column_type) : undefined,
      has_active_schedule: isSet(object.has_active_schedule)
        ? globalThis.Boolean(object.has_active_schedule)
        : undefined,
      incomplete: isSet(object.incomplete) ? globalThis.Boolean(object.incomplete) : undefined,
    };
  },

  toJSON(message: Header): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.type !== undefined) {
      obj.type = metadataTypeEnumToJSON(message.type);
    }
    if (message.owner_id !== undefined) {
      obj.owner_id = message.owner_id;
    }
    if (message.author_id !== undefined) {
      obj.author_id = message.author_id;
    }
    if (message.author_name !== undefined) {
      obj.author_name = message.author_name;
    }
    if (message.created_date_ms !== undefined) {
      obj.created_date_ms = Math.round(message.created_date_ms);
    }
    if (message.last_modified_date_ms !== undefined) {
      obj.last_modified_date_ms = Math.round(message.last_modified_date_ms);
    }
    if (message.last_modified_by !== undefined) {
      obj.last_modified_by = message.last_modified_by;
    }
    if (message.last_modified_by_name !== undefined) {
      obj.last_modified_by_name = message.last_modified_by_name;
    }
    if (message.status_flag !== undefined) {
      obj.status_flag = headerStatusToJSON(message.status_flag);
    }
    if (message.benchmark_type !== undefined) {
      obj.benchmark_type = benchmarkTypeToJSON(message.benchmark_type);
    }
    if (message.column_type !== undefined) {
      obj.column_type = columnTypeToJSON(message.column_type);
    }
    if (message.has_active_schedule !== undefined) {
      obj.has_active_schedule = message.has_active_schedule;
    }
    if (message.incomplete !== undefined) {
      obj.incomplete = message.incomplete;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Header>, I>>(base?: I): Header {
    return Header.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Header>, I>>(object: I): Header {
    const message = createBaseHeader();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.type = object.type ?? undefined;
    message.owner_id = object.owner_id ?? undefined;
    message.author_id = object.author_id ?? undefined;
    message.author_name = object.author_name ?? undefined;
    message.created_date_ms = object.created_date_ms ?? undefined;
    message.last_modified_date_ms = object.last_modified_date_ms ?? undefined;
    message.last_modified_by = object.last_modified_by ?? undefined;
    message.last_modified_by_name = object.last_modified_by_name ?? undefined;
    message.status_flag = object.status_flag ?? undefined;
    message.benchmark_type = object.benchmark_type ?? undefined;
    message.column_type = object.column_type ?? undefined;
    message.has_active_schedule = object.has_active_schedule ?? undefined;
    message.incomplete = object.incomplete ?? undefined;
    return message;
  },
};

function createBaseDataSourceInfo(): DataSourceInfo {
  return {
    source_type: undefined,
    db_name: undefined,
    schema_name: undefined,
    table_name: undefined,
    ts_worksheet_id: undefined,
  };
}

export const DataSourceInfo: MessageFns<DataSourceInfo> = {
  encode(message: DataSourceInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.source_type !== undefined) {
      writer.uint32(8).int32(message.source_type);
    }
    if (message.db_name !== undefined) {
      writer.uint32(18).string(message.db_name);
    }
    if (message.schema_name !== undefined) {
      writer.uint32(26).string(message.schema_name);
    }
    if (message.table_name !== undefined) {
      writer.uint32(34).string(message.table_name);
    }
    if (message.ts_worksheet_id !== undefined) {
      writer.uint32(42).string(message.ts_worksheet_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataSourceInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataSourceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.source_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.db_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.schema_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.table_name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ts_worksheet_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataSourceInfo {
    return {
      source_type: isSet(object.source_type) ? dataSourceTypeFromJSON(object.source_type) : undefined,
      db_name: isSet(object.db_name) ? globalThis.String(object.db_name) : undefined,
      schema_name: isSet(object.schema_name) ? globalThis.String(object.schema_name) : undefined,
      table_name: isSet(object.table_name) ? globalThis.String(object.table_name) : undefined,
      ts_worksheet_id: isSet(object.ts_worksheet_id) ? globalThis.String(object.ts_worksheet_id) : undefined,
    };
  },

  toJSON(message: DataSourceInfo): unknown {
    const obj: any = {};
    if (message.source_type !== undefined) {
      obj.source_type = dataSourceTypeToJSON(message.source_type);
    }
    if (message.db_name !== undefined) {
      obj.db_name = message.db_name;
    }
    if (message.schema_name !== undefined) {
      obj.schema_name = message.schema_name;
    }
    if (message.table_name !== undefined) {
      obj.table_name = message.table_name;
    }
    if (message.ts_worksheet_id !== undefined) {
      obj.ts_worksheet_id = message.ts_worksheet_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataSourceInfo>, I>>(base?: I): DataSourceInfo {
    return DataSourceInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataSourceInfo>, I>>(object: I): DataSourceInfo {
    const message = createBaseDataSourceInfo();
    message.source_type = object.source_type ?? undefined;
    message.db_name = object.db_name ?? undefined;
    message.schema_name = object.schema_name ?? undefined;
    message.table_name = object.table_name ?? undefined;
    message.ts_worksheet_id = object.ts_worksheet_id ?? undefined;
    return message;
  },
};

function createBaseColumnInfo(): ColumnInfo {
  return {
    header: undefined,
    source_column_name: undefined,
    data_type: undefined,
    column_type: undefined,
    default_aggregation: undefined,
  };
}

export const ColumnInfo: MessageFns<ColumnInfo> = {
  encode(message: ColumnInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.source_column_name !== undefined) {
      writer.uint32(18).string(message.source_column_name);
    }
    if (message.data_type !== undefined) {
      writer.uint32(24).int32(message.data_type);
    }
    if (message.column_type !== undefined) {
      writer.uint32(32).int32(message.column_type);
    }
    if (message.default_aggregation !== undefined) {
      writer.uint32(40).int32(message.default_aggregation);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColumnInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumnInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.source_column_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.data_type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.column_type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.default_aggregation = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColumnInfo {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      source_column_name: isSet(object.source_column_name) ? globalThis.String(object.source_column_name) : undefined,
      data_type: isSet(object.data_type) ? dataTypeFromJSON(object.data_type) : undefined,
      column_type: isSet(object.column_type) ? columnTypeFromJSON(object.column_type) : undefined,
      default_aggregation: isSet(object.default_aggregation)
        ? aggregationTypeFromJSON(object.default_aggregation)
        : undefined,
    };
  },

  toJSON(message: ColumnInfo): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.source_column_name !== undefined) {
      obj.source_column_name = message.source_column_name;
    }
    if (message.data_type !== undefined) {
      obj.data_type = dataTypeToJSON(message.data_type);
    }
    if (message.column_type !== undefined) {
      obj.column_type = columnTypeToJSON(message.column_type);
    }
    if (message.default_aggregation !== undefined) {
      obj.default_aggregation = aggregationTypeToJSON(message.default_aggregation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColumnInfo>, I>>(base?: I): ColumnInfo {
    return ColumnInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColumnInfo>, I>>(object: I): ColumnInfo {
    const message = createBaseColumnInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.source_column_name = object.source_column_name ?? undefined;
    message.data_type = object.data_type ?? undefined;
    message.column_type = object.column_type ?? undefined;
    message.default_aggregation = object.default_aggregation ?? undefined;
    return message;
  },
};

function createBaseModelInfo(): ModelInfo {
  return { header: undefined, data_source: undefined, columns: [], is_target_model: undefined };
}

export const ModelInfo: MessageFns<ModelInfo> = {
  encode(message: ModelInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.data_source !== undefined) {
      DataSourceInfo.encode(message.data_source, writer.uint32(18).fork()).join();
    }
    for (const v of message.columns) {
      ColumnInfo.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.is_target_model !== undefined) {
      writer.uint32(32).bool(message.is_target_model);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModelInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModelInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data_source = DataSourceInfo.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.columns.push(ColumnInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_target_model = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModelInfo {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      data_source: isSet(object.data_source) ? DataSourceInfo.fromJSON(object.data_source) : undefined,
      columns: globalThis.Array.isArray(object?.columns) ? object.columns.map((e: any) => ColumnInfo.fromJSON(e)) : [],
      is_target_model: isSet(object.is_target_model) ? globalThis.Boolean(object.is_target_model) : undefined,
    };
  },

  toJSON(message: ModelInfo): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.data_source !== undefined) {
      obj.data_source = DataSourceInfo.toJSON(message.data_source);
    }
    if (message.columns?.length) {
      obj.columns = message.columns.map((e) => ColumnInfo.toJSON(e));
    }
    if (message.is_target_model !== undefined) {
      obj.is_target_model = message.is_target_model;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModelInfo>, I>>(base?: I): ModelInfo {
    return ModelInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModelInfo>, I>>(object: I): ModelInfo {
    const message = createBaseModelInfo();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.data_source = (object.data_source !== undefined && object.data_source !== null)
      ? DataSourceInfo.fromPartial(object.data_source)
      : undefined;
    message.columns = object.columns?.map((e) => ColumnInfo.fromPartial(e)) || [];
    message.is_target_model = object.is_target_model ?? undefined;
    return message;
  },
};

function createBaseObservationColumnProto(): ObservationColumnProto {
  return {
    column_id: undefined,
    logical_column_header: undefined,
    kg_column_header: undefined,
    aggregation: undefined,
    time_bucket: undefined,
    sort_by: undefined,
    is_material: undefined,
    column_type: undefined,
    data_type: undefined,
  };
}

export const ObservationColumnProto: MessageFns<ObservationColumnProto> = {
  encode(message: ObservationColumnProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column_id !== undefined) {
      writer.uint32(10).string(message.column_id);
    }
    if (message.logical_column_header !== undefined) {
      Header.encode(message.logical_column_header, writer.uint32(18).fork()).join();
    }
    if (message.kg_column_header !== undefined) {
      Header.encode(message.kg_column_header, writer.uint32(26).fork()).join();
    }
    if (message.aggregation !== undefined) {
      writer.uint32(32).int32(message.aggregation);
    }
    if (message.time_bucket !== undefined) {
      writer.uint32(40).int32(message.time_bucket);
    }
    if (message.sort_by !== undefined) {
      writer.uint32(48).int32(message.sort_by);
    }
    if (message.is_material !== undefined) {
      writer.uint32(56).bool(message.is_material);
    }
    if (message.column_type !== undefined) {
      writer.uint32(64).int32(message.column_type);
    }
    if (message.data_type !== undefined) {
      writer.uint32(72).int32(message.data_type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObservationColumnProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObservationColumnProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.logical_column_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.kg_column_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.aggregation = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.time_bucket = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.sort_by = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.is_material = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.column_type = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.data_type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObservationColumnProto {
    return {
      column_id: isSet(object.column_id) ? globalThis.String(object.column_id) : undefined,
      logical_column_header: isSet(object.logical_column_header)
        ? Header.fromJSON(object.logical_column_header)
        : undefined,
      kg_column_header: isSet(object.kg_column_header) ? Header.fromJSON(object.kg_column_header) : undefined,
      aggregation: isSet(object.aggregation) ? aggregationTypeFromJSON(object.aggregation) : undefined,
      time_bucket: isSet(object.time_bucket) ? timeBucketFromJSON(object.time_bucket) : undefined,
      sort_by: isSet(object.sort_by) ? sortByEnumFromJSON(object.sort_by) : undefined,
      is_material: isSet(object.is_material) ? globalThis.Boolean(object.is_material) : undefined,
      column_type: isSet(object.column_type) ? columnTypeFromJSON(object.column_type) : undefined,
      data_type: isSet(object.data_type) ? dataTypeFromJSON(object.data_type) : undefined,
    };
  },

  toJSON(message: ObservationColumnProto): unknown {
    const obj: any = {};
    if (message.column_id !== undefined) {
      obj.column_id = message.column_id;
    }
    if (message.logical_column_header !== undefined) {
      obj.logical_column_header = Header.toJSON(message.logical_column_header);
    }
    if (message.kg_column_header !== undefined) {
      obj.kg_column_header = Header.toJSON(message.kg_column_header);
    }
    if (message.aggregation !== undefined) {
      obj.aggregation = aggregationTypeToJSON(message.aggregation);
    }
    if (message.time_bucket !== undefined) {
      obj.time_bucket = timeBucketToJSON(message.time_bucket);
    }
    if (message.sort_by !== undefined) {
      obj.sort_by = sortByEnumToJSON(message.sort_by);
    }
    if (message.is_material !== undefined) {
      obj.is_material = message.is_material;
    }
    if (message.column_type !== undefined) {
      obj.column_type = columnTypeToJSON(message.column_type);
    }
    if (message.data_type !== undefined) {
      obj.data_type = dataTypeToJSON(message.data_type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObservationColumnProto>, I>>(base?: I): ObservationColumnProto {
    return ObservationColumnProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObservationColumnProto>, I>>(object: I): ObservationColumnProto {
    const message = createBaseObservationColumnProto();
    message.column_id = object.column_id ?? undefined;
    message.logical_column_header =
      (object.logical_column_header !== undefined && object.logical_column_header !== null)
        ? Header.fromPartial(object.logical_column_header)
        : undefined;
    message.kg_column_header = (object.kg_column_header !== undefined && object.kg_column_header !== null)
      ? Header.fromPartial(object.kg_column_header)
      : undefined;
    message.aggregation = object.aggregation ?? undefined;
    message.time_bucket = object.time_bucket ?? undefined;
    message.sort_by = object.sort_by ?? undefined;
    message.is_material = object.is_material ?? undefined;
    message.column_type = object.column_type ?? undefined;
    message.data_type = object.data_type ?? undefined;
    return message;
  },
};

function createBaseFilterProto(): FilterProto {
  return {
    filter_id: undefined,
    logical_column_header: undefined,
    kg_column_header: undefined,
    operator: undefined,
    values: [],
    logical_column: undefined,
    date_filter: undefined,
    calculated_date_ranges: [],
    is_hidden: undefined,
  };
}

export const FilterProto: MessageFns<FilterProto> = {
  encode(message: FilterProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filter_id !== undefined) {
      writer.uint32(10).string(message.filter_id);
    }
    if (message.logical_column_header !== undefined) {
      Header.encode(message.logical_column_header, writer.uint32(18).fork()).join();
    }
    if (message.kg_column_header !== undefined) {
      Header.encode(message.kg_column_header, writer.uint32(26).fork()).join();
    }
    if (message.operator !== undefined) {
      writer.uint32(32).int32(message.operator);
    }
    for (const v of message.values) {
      writer.uint32(42).string(v!);
    }
    if (message.logical_column !== undefined) {
      ColumnInfo.encode(message.logical_column, writer.uint32(50).fork()).join();
    }
    if (message.date_filter !== undefined) {
      DateFilter.encode(message.date_filter, writer.uint32(58).fork()).join();
    }
    for (const v of message.calculated_date_ranges) {
      FilterProto_CalculatedDateRange.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.is_hidden !== undefined) {
      writer.uint32(72).bool(message.is_hidden);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filter_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.logical_column_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.kg_column_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.operator = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.values.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.logical_column = ColumnInfo.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.date_filter = DateFilter.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.calculated_date_ranges.push(FilterProto_CalculatedDateRange.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.is_hidden = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FilterProto {
    return {
      filter_id: isSet(object.filter_id) ? globalThis.String(object.filter_id) : undefined,
      logical_column_header: isSet(object.logical_column_header)
        ? Header.fromJSON(object.logical_column_header)
        : undefined,
      kg_column_header: isSet(object.kg_column_header) ? Header.fromJSON(object.kg_column_header) : undefined,
      operator: isSet(object.operator) ? filterOperatorFromJSON(object.operator) : undefined,
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.String(e)) : [],
      logical_column: isSet(object.logical_column) ? ColumnInfo.fromJSON(object.logical_column) : undefined,
      date_filter: isSet(object.date_filter) ? DateFilter.fromJSON(object.date_filter) : undefined,
      calculated_date_ranges: globalThis.Array.isArray(object?.calculated_date_ranges)
        ? object.calculated_date_ranges.map((e: any) => FilterProto_CalculatedDateRange.fromJSON(e))
        : [],
      is_hidden: isSet(object.is_hidden) ? globalThis.Boolean(object.is_hidden) : undefined,
    };
  },

  toJSON(message: FilterProto): unknown {
    const obj: any = {};
    if (message.filter_id !== undefined) {
      obj.filter_id = message.filter_id;
    }
    if (message.logical_column_header !== undefined) {
      obj.logical_column_header = Header.toJSON(message.logical_column_header);
    }
    if (message.kg_column_header !== undefined) {
      obj.kg_column_header = Header.toJSON(message.kg_column_header);
    }
    if (message.operator !== undefined) {
      obj.operator = filterOperatorToJSON(message.operator);
    }
    if (message.values?.length) {
      obj.values = message.values;
    }
    if (message.logical_column !== undefined) {
      obj.logical_column = ColumnInfo.toJSON(message.logical_column);
    }
    if (message.date_filter !== undefined) {
      obj.date_filter = DateFilter.toJSON(message.date_filter);
    }
    if (message.calculated_date_ranges?.length) {
      obj.calculated_date_ranges = message.calculated_date_ranges.map((e) => FilterProto_CalculatedDateRange.toJSON(e));
    }
    if (message.is_hidden !== undefined) {
      obj.is_hidden = message.is_hidden;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterProto>, I>>(base?: I): FilterProto {
    return FilterProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterProto>, I>>(object: I): FilterProto {
    const message = createBaseFilterProto();
    message.filter_id = object.filter_id ?? undefined;
    message.logical_column_header =
      (object.logical_column_header !== undefined && object.logical_column_header !== null)
        ? Header.fromPartial(object.logical_column_header)
        : undefined;
    message.kg_column_header = (object.kg_column_header !== undefined && object.kg_column_header !== null)
      ? Header.fromPartial(object.kg_column_header)
      : undefined;
    message.operator = object.operator ?? undefined;
    message.values = object.values?.map((e) => e) || [];
    message.logical_column = (object.logical_column !== undefined && object.logical_column !== null)
      ? ColumnInfo.fromPartial(object.logical_column)
      : undefined;
    message.date_filter = (object.date_filter !== undefined && object.date_filter !== null)
      ? DateFilter.fromPartial(object.date_filter)
      : undefined;
    message.calculated_date_ranges =
      object.calculated_date_ranges?.map((e) => FilterProto_CalculatedDateRange.fromPartial(e)) || [];
    message.is_hidden = object.is_hidden ?? undefined;
    return message;
  },
};

function createBaseFilterProto_CalculatedDateRange(): FilterProto_CalculatedDateRange {
  return { operator: undefined, date_epoch_sec: undefined };
}

export const FilterProto_CalculatedDateRange: MessageFns<FilterProto_CalculatedDateRange> = {
  encode(message: FilterProto_CalculatedDateRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.operator !== undefined) {
      writer.uint32(8).int32(message.operator);
    }
    if (message.date_epoch_sec !== undefined) {
      writer.uint32(16).int64(message.date_epoch_sec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterProto_CalculatedDateRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterProto_CalculatedDateRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.operator = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.date_epoch_sec = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FilterProto_CalculatedDateRange {
    return {
      operator: isSet(object.operator) ? filterOperatorFromJSON(object.operator) : undefined,
      date_epoch_sec: isSet(object.date_epoch_sec) ? globalThis.Number(object.date_epoch_sec) : undefined,
    };
  },

  toJSON(message: FilterProto_CalculatedDateRange): unknown {
    const obj: any = {};
    if (message.operator !== undefined) {
      obj.operator = filterOperatorToJSON(message.operator);
    }
    if (message.date_epoch_sec !== undefined) {
      obj.date_epoch_sec = Math.round(message.date_epoch_sec);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterProto_CalculatedDateRange>, I>>(base?: I): FilterProto_CalculatedDateRange {
    return FilterProto_CalculatedDateRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterProto_CalculatedDateRange>, I>>(
    object: I,
  ): FilterProto_CalculatedDateRange {
    const message = createBaseFilterProto_CalculatedDateRange();
    message.operator = object.operator ?? undefined;
    message.date_epoch_sec = object.date_epoch_sec ?? undefined;
    return message;
  },
};

function createBaseObservationContentProto(): ObservationContentProto {
  return { observation_columns: [], filters: [] };
}

export const ObservationContentProto: MessageFns<ObservationContentProto> = {
  encode(message: ObservationContentProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.observation_columns) {
      ObservationColumnProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.filters) {
      FilterProto.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObservationContentProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObservationContentProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.observation_columns.push(ObservationColumnProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.filters.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObservationContentProto {
    return {
      observation_columns: globalThis.Array.isArray(object?.observation_columns)
        ? object.observation_columns.map((e: any) => ObservationColumnProto.fromJSON(e))
        : [],
      filters: globalThis.Array.isArray(object?.filters) ? object.filters.map((e: any) => FilterProto.fromJSON(e)) : [],
    };
  },

  toJSON(message: ObservationContentProto): unknown {
    const obj: any = {};
    if (message.observation_columns?.length) {
      obj.observation_columns = message.observation_columns.map((e) => ObservationColumnProto.toJSON(e));
    }
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => FilterProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObservationContentProto>, I>>(base?: I): ObservationContentProto {
    return ObservationContentProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObservationContentProto>, I>>(object: I): ObservationContentProto {
    const message = createBaseObservationContentProto();
    message.observation_columns = object.observation_columns?.map((e) => ObservationColumnProto.fromPartial(e)) || [];
    message.filters = object.filters?.map((e) => FilterProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseObservationProto(): ObservationProto {
  return { header: undefined, content: undefined };
}

export const ObservationProto: MessageFns<ObservationProto> = {
  encode(message: ObservationProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.content !== undefined) {
      ObservationContentProto.encode(message.content, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObservationProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObservationProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = ObservationContentProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObservationProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      content: isSet(object.content) ? ObservationContentProto.fromJSON(object.content) : undefined,
    };
  },

  toJSON(message: ObservationProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.content !== undefined) {
      obj.content = ObservationContentProto.toJSON(message.content);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObservationProto>, I>>(base?: I): ObservationProto {
    return ObservationProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObservationProto>, I>>(object: I): ObservationProto {
    const message = createBaseObservationProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.content = (object.content !== undefined && object.content !== null)
      ? ObservationContentProto.fromPartial(object.content)
      : undefined;
    return message;
  },
};

function createBaseMetricProto(): MetricProto {
  return {
    header: undefined,
    definition: undefined,
    edges: [],
    format: undefined,
    type: undefined,
    polarity: undefined,
    outcome_profile: undefined,
    material_column_header: undefined,
    material: undefined,
  };
}

export const MetricProto: MessageFns<MetricProto> = {
  encode(message: MetricProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.definition !== undefined) {
      ObservationContentProto.encode(message.definition, writer.uint32(18).fork()).join();
    }
    for (const v of message.edges) {
      MetricEdgeProto.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.format !== undefined) {
      FormatProto.encode(message.format, writer.uint32(34).fork()).join();
    }
    if (message.type !== undefined) {
      writer.uint32(40).int32(message.type);
    }
    if (message.polarity !== undefined) {
      writer.uint32(48).int32(message.polarity);
    }
    if (message.outcome_profile !== undefined) {
      writer.uint32(58).string(message.outcome_profile);
    }
    if (message.material_column_header !== undefined) {
      Header.encode(message.material_column_header, writer.uint32(66).fork()).join();
    }
    if (message.material !== undefined) {
      MetricProto.encode(message.material, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MetricProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetricProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.definition = ObservationContentProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.edges.push(MetricEdgeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.format = FormatProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.polarity = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.outcome_profile = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.material_column_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.material = MetricProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetricProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      definition: isSet(object.definition) ? ObservationContentProto.fromJSON(object.definition) : undefined,
      edges: globalThis.Array.isArray(object?.edges) ? object.edges.map((e: any) => MetricEdgeProto.fromJSON(e)) : [],
      format: isSet(object.format) ? FormatProto.fromJSON(object.format) : undefined,
      type: isSet(object.type) ? metricTypeFromJSON(object.type) : undefined,
      polarity: isSet(object.polarity) ? polarityEnumFromJSON(object.polarity) : undefined,
      outcome_profile: isSet(object.outcome_profile) ? globalThis.String(object.outcome_profile) : undefined,
      material_column_header: isSet(object.material_column_header)
        ? Header.fromJSON(object.material_column_header)
        : undefined,
      material: isSet(object.material) ? MetricProto.fromJSON(object.material) : undefined,
    };
  },

  toJSON(message: MetricProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.definition !== undefined) {
      obj.definition = ObservationContentProto.toJSON(message.definition);
    }
    if (message.edges?.length) {
      obj.edges = message.edges.map((e) => MetricEdgeProto.toJSON(e));
    }
    if (message.format !== undefined) {
      obj.format = FormatProto.toJSON(message.format);
    }
    if (message.type !== undefined) {
      obj.type = metricTypeToJSON(message.type);
    }
    if (message.polarity !== undefined) {
      obj.polarity = polarityEnumToJSON(message.polarity);
    }
    if (message.outcome_profile !== undefined) {
      obj.outcome_profile = message.outcome_profile;
    }
    if (message.material_column_header !== undefined) {
      obj.material_column_header = Header.toJSON(message.material_column_header);
    }
    if (message.material !== undefined) {
      obj.material = MetricProto.toJSON(message.material);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MetricProto>, I>>(base?: I): MetricProto {
    return MetricProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MetricProto>, I>>(object: I): MetricProto {
    const message = createBaseMetricProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.definition = (object.definition !== undefined && object.definition !== null)
      ? ObservationContentProto.fromPartial(object.definition)
      : undefined;
    message.edges = object.edges?.map((e) => MetricEdgeProto.fromPartial(e)) || [];
    message.format = (object.format !== undefined && object.format !== null)
      ? FormatProto.fromPartial(object.format)
      : undefined;
    message.type = object.type ?? undefined;
    message.polarity = object.polarity ?? undefined;
    message.outcome_profile = object.outcome_profile ?? undefined;
    message.material_column_header =
      (object.material_column_header !== undefined && object.material_column_header !== null)
        ? Header.fromPartial(object.material_column_header)
        : undefined;
    message.material = (object.material !== undefined && object.material !== null)
      ? MetricProto.fromPartial(object.material)
      : undefined;
    return message;
  },
};

function createBaseMetricEdgeProto(): MetricEdgeProto {
  return {
    edge_type: undefined,
    edge_weight: undefined,
    source_metric_id: undefined,
    header: undefined,
    related_attribute: undefined,
    benchmark: undefined,
    fundamental_relationship: undefined,
  };
}

export const MetricEdgeProto: MessageFns<MetricEdgeProto> = {
  encode(message: MetricEdgeProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.edge_type !== undefined) {
      writer.uint32(8).int32(message.edge_type);
    }
    if (message.edge_weight !== undefined) {
      writer.uint32(17).double(message.edge_weight);
    }
    if (message.source_metric_id !== undefined) {
      writer.uint32(26).string(message.source_metric_id);
    }
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(34).fork()).join();
    }
    if (message.related_attribute !== undefined) {
      Header.encode(message.related_attribute, writer.uint32(42).fork()).join();
    }
    if (message.benchmark !== undefined) {
      BenchmarkProto.encode(message.benchmark, writer.uint32(50).fork()).join();
    }
    if (message.fundamental_relationship !== undefined) {
      FundamentalRelationshipProto.encode(message.fundamental_relationship, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MetricEdgeProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetricEdgeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.edge_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.edge_weight = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.source_metric_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.related_attribute = Header.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.benchmark = BenchmarkProto.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.fundamental_relationship = FundamentalRelationshipProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetricEdgeProto {
    return {
      edge_type: isSet(object.edge_type) ? metricEdgeTypeFromJSON(object.edge_type) : undefined,
      edge_weight: isSet(object.edge_weight) ? globalThis.Number(object.edge_weight) : undefined,
      source_metric_id: isSet(object.source_metric_id) ? globalThis.String(object.source_metric_id) : undefined,
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      related_attribute: isSet(object.related_attribute) ? Header.fromJSON(object.related_attribute) : undefined,
      benchmark: isSet(object.benchmark) ? BenchmarkProto.fromJSON(object.benchmark) : undefined,
      fundamental_relationship: isSet(object.fundamental_relationship)
        ? FundamentalRelationshipProto.fromJSON(object.fundamental_relationship)
        : undefined,
    };
  },

  toJSON(message: MetricEdgeProto): unknown {
    const obj: any = {};
    if (message.edge_type !== undefined) {
      obj.edge_type = metricEdgeTypeToJSON(message.edge_type);
    }
    if (message.edge_weight !== undefined) {
      obj.edge_weight = message.edge_weight;
    }
    if (message.source_metric_id !== undefined) {
      obj.source_metric_id = message.source_metric_id;
    }
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.related_attribute !== undefined) {
      obj.related_attribute = Header.toJSON(message.related_attribute);
    }
    if (message.benchmark !== undefined) {
      obj.benchmark = BenchmarkProto.toJSON(message.benchmark);
    }
    if (message.fundamental_relationship !== undefined) {
      obj.fundamental_relationship = FundamentalRelationshipProto.toJSON(message.fundamental_relationship);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MetricEdgeProto>, I>>(base?: I): MetricEdgeProto {
    return MetricEdgeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MetricEdgeProto>, I>>(object: I): MetricEdgeProto {
    const message = createBaseMetricEdgeProto();
    message.edge_type = object.edge_type ?? undefined;
    message.edge_weight = object.edge_weight ?? undefined;
    message.source_metric_id = object.source_metric_id ?? undefined;
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.related_attribute = (object.related_attribute !== undefined && object.related_attribute !== null)
      ? Header.fromPartial(object.related_attribute)
      : undefined;
    message.benchmark = (object.benchmark !== undefined && object.benchmark !== null)
      ? BenchmarkProto.fromPartial(object.benchmark)
      : undefined;
    message.fundamental_relationship =
      (object.fundamental_relationship !== undefined && object.fundamental_relationship !== null)
        ? FundamentalRelationshipProto.fromPartial(object.fundamental_relationship)
        : undefined;
    return message;
  },
};

function createBaseBenchmarkProto(): BenchmarkProto {
  return {
    header: undefined,
    benchmark_filters: [],
    variance_tolerance: undefined,
    last_n_period_average: undefined,
    growth_benchmarks: [],
    definition: undefined,
  };
}

export const BenchmarkProto: MessageFns<BenchmarkProto> = {
  encode(message: BenchmarkProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.benchmark_filters) {
      FilterProto.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.variance_tolerance !== undefined) {
      writer.uint32(25).double(message.variance_tolerance);
    }
    if (message.last_n_period_average !== undefined) {
      writer.uint32(32).int32(message.last_n_period_average);
    }
    for (const v of message.growth_benchmarks) {
      GrowthBenchmarkProto.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.definition !== undefined) {
      ObservationContentProto.encode(message.definition, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BenchmarkProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBenchmarkProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.benchmark_filters.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.variance_tolerance = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.last_n_period_average = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.growth_benchmarks.push(GrowthBenchmarkProto.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.definition = ObservationContentProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BenchmarkProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      benchmark_filters: globalThis.Array.isArray(object?.benchmark_filters)
        ? object.benchmark_filters.map((e: any) => FilterProto.fromJSON(e))
        : [],
      variance_tolerance: isSet(object.variance_tolerance) ? globalThis.Number(object.variance_tolerance) : undefined,
      last_n_period_average: isSet(object.last_n_period_average)
        ? globalThis.Number(object.last_n_period_average)
        : undefined,
      growth_benchmarks: globalThis.Array.isArray(object?.growth_benchmarks)
        ? object.growth_benchmarks.map((e: any) => GrowthBenchmarkProto.fromJSON(e))
        : [],
      definition: isSet(object.definition) ? ObservationContentProto.fromJSON(object.definition) : undefined,
    };
  },

  toJSON(message: BenchmarkProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.benchmark_filters?.length) {
      obj.benchmark_filters = message.benchmark_filters.map((e) => FilterProto.toJSON(e));
    }
    if (message.variance_tolerance !== undefined) {
      obj.variance_tolerance = message.variance_tolerance;
    }
    if (message.last_n_period_average !== undefined) {
      obj.last_n_period_average = Math.round(message.last_n_period_average);
    }
    if (message.growth_benchmarks?.length) {
      obj.growth_benchmarks = message.growth_benchmarks.map((e) => GrowthBenchmarkProto.toJSON(e));
    }
    if (message.definition !== undefined) {
      obj.definition = ObservationContentProto.toJSON(message.definition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BenchmarkProto>, I>>(base?: I): BenchmarkProto {
    return BenchmarkProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BenchmarkProto>, I>>(object: I): BenchmarkProto {
    const message = createBaseBenchmarkProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.benchmark_filters = object.benchmark_filters?.map((e) => FilterProto.fromPartial(e)) || [];
    message.variance_tolerance = object.variance_tolerance ?? undefined;
    message.last_n_period_average = object.last_n_period_average ?? undefined;
    message.growth_benchmarks = object.growth_benchmarks?.map((e) => GrowthBenchmarkProto.fromPartial(e)) || [];
    message.definition = (object.definition !== undefined && object.definition !== null)
      ? ObservationContentProto.fromPartial(object.definition)
      : undefined;
    return message;
  },
};

function createBaseCorrelationProto(): CorrelationProto {
  return { correlation_factor: undefined, related_metric_header: undefined, related_column_header: undefined };
}

export const CorrelationProto: MessageFns<CorrelationProto> = {
  encode(message: CorrelationProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.correlation_factor !== undefined) {
      writer.uint32(9).double(message.correlation_factor);
    }
    if (message.related_metric_header !== undefined) {
      Header.encode(message.related_metric_header, writer.uint32(18).fork()).join();
    }
    if (message.related_column_header !== undefined) {
      Header.encode(message.related_column_header, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CorrelationProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCorrelationProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.correlation_factor = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.related_metric_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.related_column_header = Header.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CorrelationProto {
    return {
      correlation_factor: isSet(object.correlation_factor) ? globalThis.Number(object.correlation_factor) : undefined,
      related_metric_header: isSet(object.related_metric_header)
        ? Header.fromJSON(object.related_metric_header)
        : undefined,
      related_column_header: isSet(object.related_column_header)
        ? Header.fromJSON(object.related_column_header)
        : undefined,
    };
  },

  toJSON(message: CorrelationProto): unknown {
    const obj: any = {};
    if (message.correlation_factor !== undefined) {
      obj.correlation_factor = message.correlation_factor;
    }
    if (message.related_metric_header !== undefined) {
      obj.related_metric_header = Header.toJSON(message.related_metric_header);
    }
    if (message.related_column_header !== undefined) {
      obj.related_column_header = Header.toJSON(message.related_column_header);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CorrelationProto>, I>>(base?: I): CorrelationProto {
    return CorrelationProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CorrelationProto>, I>>(object: I): CorrelationProto {
    const message = createBaseCorrelationProto();
    message.correlation_factor = object.correlation_factor ?? undefined;
    message.related_metric_header =
      (object.related_metric_header !== undefined && object.related_metric_header !== null)
        ? Header.fromPartial(object.related_metric_header)
        : undefined;
    message.related_column_header =
      (object.related_column_header !== undefined && object.related_column_header !== null)
        ? Header.fromPartial(object.related_column_header)
        : undefined;
    return message;
  },
};

function createBaseFundamentalRelationshipProto(): FundamentalRelationshipProto {
  return {
    header: undefined,
    is_formula: undefined,
    formula_expression: undefined,
    correlations: [],
    is_additive: undefined,
  };
}

export const FundamentalRelationshipProto: MessageFns<FundamentalRelationshipProto> = {
  encode(message: FundamentalRelationshipProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.is_formula !== undefined) {
      writer.uint32(16).bool(message.is_formula);
    }
    if (message.formula_expression !== undefined) {
      writer.uint32(26).string(message.formula_expression);
    }
    for (const v of message.correlations) {
      CorrelationProto.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.is_additive !== undefined) {
      writer.uint32(40).bool(message.is_additive);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FundamentalRelationshipProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFundamentalRelationshipProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.is_formula = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.formula_expression = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.correlations.push(CorrelationProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.is_additive = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FundamentalRelationshipProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      is_formula: isSet(object.is_formula) ? globalThis.Boolean(object.is_formula) : undefined,
      formula_expression: isSet(object.formula_expression) ? globalThis.String(object.formula_expression) : undefined,
      correlations: globalThis.Array.isArray(object?.correlations)
        ? object.correlations.map((e: any) => CorrelationProto.fromJSON(e))
        : [],
      is_additive: isSet(object.is_additive) ? globalThis.Boolean(object.is_additive) : undefined,
    };
  },

  toJSON(message: FundamentalRelationshipProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.is_formula !== undefined) {
      obj.is_formula = message.is_formula;
    }
    if (message.formula_expression !== undefined) {
      obj.formula_expression = message.formula_expression;
    }
    if (message.correlations?.length) {
      obj.correlations = message.correlations.map((e) => CorrelationProto.toJSON(e));
    }
    if (message.is_additive !== undefined) {
      obj.is_additive = message.is_additive;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FundamentalRelationshipProto>, I>>(base?: I): FundamentalRelationshipProto {
    return FundamentalRelationshipProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FundamentalRelationshipProto>, I>>(object: I): FundamentalRelationshipProto {
    const message = createBaseFundamentalRelationshipProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.is_formula = object.is_formula ?? undefined;
    message.formula_expression = object.formula_expression ?? undefined;
    message.correlations = object.correlations?.map((e) => CorrelationProto.fromPartial(e)) || [];
    message.is_additive = object.is_additive ?? undefined;
    return message;
  },
};

function createBaseFormatProto(): FormatProto {
  return { currency_code: undefined, percentage: undefined, suffix: undefined, num_decimals: undefined };
}

export const FormatProto: MessageFns<FormatProto> = {
  encode(message: FormatProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currency_code !== undefined) {
      writer.uint32(10).string(message.currency_code);
    }
    if (message.percentage !== undefined) {
      writer.uint32(16).bool(message.percentage);
    }
    if (message.suffix !== undefined) {
      writer.uint32(26).string(message.suffix);
    }
    if (message.num_decimals !== undefined) {
      writer.uint32(32).int32(message.num_decimals);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FormatProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFormatProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.currency_code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.percentage = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.suffix = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.num_decimals = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FormatProto {
    return {
      currency_code: isSet(object.currency_code) ? globalThis.String(object.currency_code) : undefined,
      percentage: isSet(object.percentage) ? globalThis.Boolean(object.percentage) : undefined,
      suffix: isSet(object.suffix) ? globalThis.String(object.suffix) : undefined,
      num_decimals: isSet(object.num_decimals) ? globalThis.Number(object.num_decimals) : undefined,
    };
  },

  toJSON(message: FormatProto): unknown {
    const obj: any = {};
    if (message.currency_code !== undefined) {
      obj.currency_code = message.currency_code;
    }
    if (message.percentage !== undefined) {
      obj.percentage = message.percentage;
    }
    if (message.suffix !== undefined) {
      obj.suffix = message.suffix;
    }
    if (message.num_decimals !== undefined) {
      obj.num_decimals = Math.round(message.num_decimals);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FormatProto>, I>>(base?: I): FormatProto {
    return FormatProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FormatProto>, I>>(object: I): FormatProto {
    const message = createBaseFormatProto();
    message.currency_code = object.currency_code ?? undefined;
    message.percentage = object.percentage ?? undefined;
    message.suffix = object.suffix ?? undefined;
    message.num_decimals = object.num_decimals ?? undefined;
    return message;
  },
};

function createBaseReportPageProto(): ReportPageProto {
  return { header: undefined, tree_headers: [] };
}

export const ReportPageProto: MessageFns<ReportPageProto> = {
  encode(message: ReportPageProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.tree_headers) {
      Header.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReportPageProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReportPageProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tree_headers.push(Header.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReportPageProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      tree_headers: globalThis.Array.isArray(object?.tree_headers)
        ? object.tree_headers.map((e: any) => Header.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ReportPageProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.tree_headers?.length) {
      obj.tree_headers = message.tree_headers.map((e) => Header.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReportPageProto>, I>>(base?: I): ReportPageProto {
    return ReportPageProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReportPageProto>, I>>(object: I): ReportPageProto {
    const message = createBaseReportPageProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.tree_headers = object.tree_headers?.map((e) => Header.fromPartial(e)) || [];
    return message;
  },
};

function createBaseReportBookProto(): ReportBookProto {
  return { header: undefined, pages: [] };
}

export const ReportBookProto: MessageFns<ReportBookProto> = {
  encode(message: ReportBookProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.pages) {
      ReportPageProto.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReportBookProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReportBookProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pages.push(ReportPageProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReportBookProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      pages: globalThis.Array.isArray(object?.pages) ? object.pages.map((e: any) => ReportPageProto.fromJSON(e)) : [],
    };
  },

  toJSON(message: ReportBookProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.pages?.length) {
      obj.pages = message.pages.map((e) => ReportPageProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReportBookProto>, I>>(base?: I): ReportBookProto {
    return ReportBookProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReportBookProto>, I>>(object: I): ReportBookProto {
    const message = createBaseReportBookProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.pages = object.pages?.map((e) => ReportPageProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseErrorDetailProto(): ErrorDetailProto {
  return { error_code: undefined, error_name: undefined, error_msg: undefined, stack_trace: undefined };
}

export const ErrorDetailProto: MessageFns<ErrorDetailProto> = {
  encode(message: ErrorDetailProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.error_code !== undefined) {
      writer.uint32(8).int32(message.error_code);
    }
    if (message.error_name !== undefined) {
      writer.uint32(18).string(message.error_name);
    }
    if (message.error_msg !== undefined) {
      writer.uint32(26).string(message.error_msg);
    }
    if (message.stack_trace !== undefined) {
      writer.uint32(34).string(message.stack_trace);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorDetailProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorDetailProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.error_code = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error_msg = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.stack_trace = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorDetailProto {
    return {
      error_code: isSet(object.error_code) ? globalThis.Number(object.error_code) : undefined,
      error_name: isSet(object.error_name) ? globalThis.String(object.error_name) : undefined,
      error_msg: isSet(object.error_msg) ? globalThis.String(object.error_msg) : undefined,
      stack_trace: isSet(object.stack_trace) ? globalThis.String(object.stack_trace) : undefined,
    };
  },

  toJSON(message: ErrorDetailProto): unknown {
    const obj: any = {};
    if (message.error_code !== undefined) {
      obj.error_code = Math.round(message.error_code);
    }
    if (message.error_name !== undefined) {
      obj.error_name = message.error_name;
    }
    if (message.error_msg !== undefined) {
      obj.error_msg = message.error_msg;
    }
    if (message.stack_trace !== undefined) {
      obj.stack_trace = message.stack_trace;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorDetailProto>, I>>(base?: I): ErrorDetailProto {
    return ErrorDetailProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorDetailProto>, I>>(object: I): ErrorDetailProto {
    const message = createBaseErrorDetailProto();
    message.error_code = object.error_code ?? undefined;
    message.error_name = object.error_name ?? undefined;
    message.error_msg = object.error_msg ?? undefined;
    message.stack_trace = object.stack_trace ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
